import { Expense } from "@/hooks/useExpenses";

interface Vehicle {
  id: string;
  name: string;
  vin?: string | null;
}

export function exportExpensesToCSV(expenses: Expense[], vehicles: Vehicle[]): void {
  // Create a vehicle ID to name map
  const vehicleMap = new Map<string, string>();
  vehicles.forEach(v => {
    vehicleMap.set(v.id, v.name);
  });

  // Define CSV headers
  const headers = [
    "Date",
    "Expense",
    "Car",
    "Expense Type",
    "Tax Category",
    "Amount",
    "Miles Driven",
    "Paid By",
    "Paid To",
    "Notes",
  ];

  // Format expenses as CSV rows
  const rows = expenses.map(expense => {
    const vehicleName = expense.vehicle_id 
      ? vehicleMap.get(expense.vehicle_id) || "" 
      : expense.vehicle_id === null 
        ? "Operations" 
        : "";

    return [
      expense.expense_date || "",
      expense.expense_name || "",
      vehicleName,
      expense.expense_type || "",
      expense.tax_category || "",
      expense.amount?.toString() || "",
      expense.mileage?.toString() || "",
      expense.paid_by || "",
      expense.paid_to || "",
      expense.notes || "",
    ];
  });

  // Escape CSV values (handle commas, quotes, newlines)
  const escapeCSV = (value: string): string => {
    if (value.includes(",") || value.includes('"') || value.includes("\n")) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  };

  // Build CSV content
  const csvContent = [
    headers.map(escapeCSV).join(","),
    ...rows.map(row => row.map(escapeCSV).join(",")),
  ].join("\n");

  // Create and trigger download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  
  // Generate filename with current date
  const today = new Date().toISOString().split("T")[0];
  link.setAttribute("href", url);
  link.setAttribute("download", `expenses-export-${today}.csv`);
  link.style.visibility = "hidden";
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  URL.revokeObjectURL(url);
}
